export const MIN_INTERVAL_DAYS = 1;
export const MAX_INTERVAL_DAYS = 730;
export const MAX_INTERVAL_MONTHS = 24;
